import React from 'react';
import { InView } from 'react-intersection-observer';
import '../styles/M365Pros.css';

const M365ProsSection = () => {
  return (
    <section className="additional-section">
      <div className="additional-container">
        <InView triggerOnce={true} threshold={0.1}>
          {({ inView, ref }) => (
            <div ref={ref} className={`additional-content ${inView ? 'animate' : ''}`}>
              <h1>Everyone's Switching to Microsoft 365</h1>
              <h1> Here's Why.</h1>
              <div className="color-boxes">
                <InView triggerOnce={true} threshold={0.1}>
                  {({ inView, ref }) => (
                    <article ref={ref} className={`color-box box1 ${inView ? 'animate' : ''}`}>
                      <h3>Unify Communication and Collaboration</h3>
                      <p>Bring together chat, email, video conferencing, and file sharing in one integrated platform, allowing your employees to collaborate in real time, reduce silos, and stay connected-anytime, anywhere!</p>
                    </article>
                  )}
                </InView>
                <InView triggerOnce={true} threshold={0.1}>
                  {({ inView, ref }) => (
                    <article ref={ref} className={`color-box box2 ${inView ? 'animate' : ''}`}>
                      <h3>Work Smarter with Built-In Intelligence</h3>
                      <p>From smart email prioritization in Outlook to design suggestions in PowerPoint and AI-powered analytics in Excel, Microsoft 365 helps users make better decisions, save time, and elevate productivity across daily tasks and long-term projects.</p>
                    </article>
                  )}
                </InView>
                <InView triggerOnce={true} threshold={0.1}>
                  {({ inView, ref }) => (
                    <article ref={ref} className={`color-box box3 ${inView ? 'animate' : ''}`}>
                      <h3>Protect what matters the most</h3>
                      <p>With advanced threat protection, identity management, and data loss prevention, Microsoft 365 safeguards your information from cyber threats while ensuring compliance-so your business stays secure without slowing down innovation or productivity.</p>
                    </article>
                  )}
                </InView>
                <InView triggerOnce={true} threshold={0.1}>
                  {({ inView, ref }) => (
                    <article ref={ref} className={`color-box box4 ${inView ? 'animate' : ''}`}>
                      <h3>Scale without complexity</h3>
                      <p>Whether you're a small team or a global enterprise, Microsoft 365 grows with you. Manage users, apps, and devices with ease, and take advantage of flexible licensing that adapts to your evolving business needs.</p>
                    </article>
                  )}
                </InView>
              </div>
            </div>
          )}
        </InView>
      </div>
    </section>
  );
};

export default M365ProsSection;